export default "__VITE_ASSET__eLYOSuJ8__"